module.exports = __webpack_public_path__ + "static/media/blog3.4104f17c.jpg";